import { priceFormatter } from '@noths/polaris-client-utils';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';
import { addDays, format } from 'date-fns';

const formatDeliveryDate = (deliveryDays: number | null) => {
  switch (deliveryDays) {
    case null:
    case undefined:
      return '';
    case 0:
      return 'Today';
    case 1:
      return 'Tomorrow';
    default:
      if (typeof deliveryDays === 'number') {
        return `${format(addDays(new Date(), deliveryDays), 'EEE do')}`;
      }
      return '';
  }
};

export const getDeliveryLabel = (
  deliveryDays: number | null,
  deliveryCost: number | null,
  currencyCode: CurrencyCode,
): string => {
  const labels: string[] = [];

  const deliveryDate = formatDeliveryDate(deliveryDays);
  if (deliveryDate) {
    labels.push(`<b>${deliveryDate}</b>`);
  }

  if (deliveryCost !== null) {
    const deliveryCostLabel =
      deliveryCost === 0
        ? '<span><b>Free</b></span>'
        : `<span>${priceFormatter(currencyCode, deliveryCost, false)}</span>`;
    labels.push(deliveryCostLabel);
  }

  return labels.join(' · ');
};
